import React, { Component } from 'react';

// this component allows alerts to be read correctly when updated
export class PersistentAlertBox extends Component {
  constructor(props){
    super(props);

    this.state = {
        showContent: true
    }
  }

  componentWillReceiveProps(nextProps) {
    setTimeout(()=>{this.setState({
      showContent: false
    })}, 10);
    setTimeout(()=>{this.setState({
      showContent: true
    })}, 50)
  }

  render() {
    const { showContent } = this.state;
    const { children } = this.props;

    return showContent ? (
      <div role="alert" aria-live="polite" className="skip">
        {children}
      </div>
    ) : null;
  }
}

export default PersistentAlertBox;
